var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity-sidebar" }, [
    _c("div", { staticClass: "top" }, [
      _c(
        "div",
        { staticClass: "first" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "", classNames: "border-none" },
              on: { click: _vm.goBack },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("chevron_left"),
              ]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.turnBack")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "second" }, [
        _c(
          "div",
          { staticClass: "btnGroup" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { classNames: "btnGroupItem selected", primary: "" },
                on: { click: _vm.goActivities },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("notification.activities")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { classNames: "btnGroupItem", ghost: "" },
                on: { click: _vm.goNotifications },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("notification.notifications")) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "third" }, [
        _c(
          "div",
          [
            _c("div", [_vm._v(_vm._s(_vm.$t("notification.selectActor")))]),
            _vm._v(" "),
            _c("a-select", {
              staticClass: "select-multiple",
              attrs: {
                mode: "multiple",
                placeholder: _vm.$t("notification.selectActor"),
                options: _vm.users,
              },
              model: {
                value: _vm.filters.actorIds,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "actorIds", $$v)
                },
                expression: "filters.actorIds",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", [_vm._v(_vm._s(_vm.$t("notification.dateBetween")))]),
          _vm._v(" "),
          _c("div", { staticClass: "date-calender" }, [
            _c("input", {
              staticClass: "custom-date-input",
              attrs: { type: "date", placeholder: _vm.$t("message.startDate") },
              domProps: { value: _vm.startDateValue },
              on: { input: _vm.onStartDateChange },
            }),
            _vm._v(" "),
            _c("input", {
              staticClass: "custom-date-input",
              attrs: { type: "date", placeholder: _vm.$t("message.endDate") },
              domProps: { value: _vm.endDateValue },
              on: { input: _vm.onEndDateChange },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", [_vm._v(_vm._s(_vm.$t("notification.actionType")))]),
            _vm._v(" "),
            _c("a-select", {
              staticClass: "select-multiple",
              attrs: {
                mode: "multiple",
                placeholder: _vm.$t("notification.actionType"),
                options: _vm.types,
              },
              model: {
                value: _vm.filters.activityTypes,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "activityTypes", $$v)
                },
                expression: "filters.activityTypes",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }